import React from 'react';

const SearchSvg = function SearchSvg() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="search-svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.32374 8.24329L11.5739 10.4937C11.8722 10.7921 11.8722 11.2895 11.5863 11.5754C11.4371 11.7246 11.2382 11.7992 11.0393 11.7992C10.8404 11.7992 10.6415 11.7246 10.4923 11.5754L8.24219 9.32499C7.3844 9.95909 6.31528 10.3445 5.17157 10.3445C2.32472 10.3445 0 8.03192 0 5.17226C0 2.32503 2.31229 0 5.17157 0C8.01842 0 10.3431 2.3126 10.3431 5.17226C10.3431 6.32856 9.95775 7.38539 9.32374 8.24329ZM5.15934 1.542C3.15784 1.542 1.5293 3.17077 1.5293 5.17253C1.5293 7.18673 3.15784 8.8155 5.15934 8.80306C7.16084 8.80306 8.78938 7.1743 8.78938 5.17253C8.78938 3.17077 7.16084 1.542 5.15934 1.542Z" fill="#1EC252" />
    </svg>
  );
};

export default SearchSvg;
